import React, { useState } from 'react'

import { useSwipeable } from 'react-swipeable'
import { Radio, Slide } from '@material-ui/core'

import { TrackLink } from 'artkive/components/Tracker'
import { ABOUT_US } from 'artkive/constants/tracker/mainNavigation'

import { PRODUCT_SLIDES } from './ProductsCarousel.constants'
import {
  Card,
  CardContent,
  Container,
  GridContainer,
  ImagePreviewContainer,
  LinkWrapper,
  LogoWrapper,
  OuterWrapper,
  PreviewGrid,
  PreviewImage,
  RadioWrapper,
  SlideWrapper,
} from './ProductsCarousel.style'

const ProductsCarousel = () => {
  const [slide, setSlide] = useState(0)

  const handleNext = () => {
    setSlide((prevSlide) => (prevSlide >= PRODUCT_SLIDES.length - 1 ? 0 : prevSlide + 1))
  }

  const handlePrev = () => {
    setSlide((prevSlide) => (prevSlide <= 0 ? PRODUCT_SLIDES.length - 1 : prevSlide - 1))
  }

  const handlers = useSwipeable({ onSwipedLeft: handleNext, onSwipedRight: handlePrev })

  return (
    <OuterWrapper>
      <Container {...handlers}>
        {PRODUCT_SLIDES.map(({ href, text, linkText, img, trackerOptions, preview }, index) => (
          <Slide key={href} in={slide === index} direction='left'>
            <SlideWrapper>
              <GridContainer container>
                <Card item xs={12} md={8}>
                  <CardContent>
                    <LogoWrapper>
                      <TrackLink
                        href={href}
                        target='_blank'
                        trackerEvent={ABOUT_US.OTHER_PROJECTS_CLICK}
                        trackerOptions={trackerOptions}
                      >
                        {img}
                      </TrackLink>
                    </LogoWrapper>
                    {text}
                    <LinkWrapper>
                      <TrackLink
                        href={href}
                        target='_blank'
                        trackerEvent={ABOUT_US.OTHER_PROJECTS_CLICK}
                        trackerOptions={trackerOptions}
                        underline='none'
                      >
                        {linkText}
                      </TrackLink>
                    </LinkWrapper>
                    <RadioWrapper>
                      <div>
                        {PRODUCT_SLIDES.map((_, nestedIndex) => (
                          <Radio
                            key={`${href}-${index}-${nestedIndex}`}
                            color='primary'
                            checked={index === nestedIndex}
                            size='small'
                            onClick={() => index !== nestedIndex && setSlide(nestedIndex)}
                          />
                        ))}
                      </div>
                    </RadioWrapper>
                  </CardContent>
                </Card>
                <PreviewGrid item xs={12} md={4}>
                  <ImagePreviewContainer>
                    <PreviewImage src={preview} loading='lazy' />
                  </ImagePreviewContainer>
                </PreviewGrid>
              </GridContainer>
            </SlideWrapper>
          </Slide>
        ))}
      </Container>
    </OuterWrapper>
  )
}

export default ProductsCarousel
